import styled from 'styled-components';
import { fromMd } from '../../constants';
import { TypeStyle } from '../TypeStyle';
export const Title = styled.div `
  ${TypeStyle.css.headlineExtraSmall}
  font-size: 20px;
  padding: ${o => o.theme.spacing(5)};
  text-align: center;

  ${fromMd} {
    font-size: 18px;
  }
`;
export const Header = styled.div `
  margin: ${o => o.theme.spacing(2)} 0 0 0;

  ${fromMd} {
    margin: ${o => o.theme.spacing(2)} ${o => o.theme.spacing(8)} 0 ${o => o.theme.spacing(8)};
  }
`;
export const Body = styled.div `
  font-weight: 400;
  margin-bottom: ${o => o.theme.spacing(2)};
`;
export const Footer = styled.div `
  ${TypeStyle.css.bodyDefault}
  background-color: ${o => o.theme.color.deprecated.stoneLight};
  border-radius: 0 0 ${o => o.theme.spacing(2)} ${o => o.theme.spacing(2)};
  height: ${o => o.theme.spacing(15)};
  text-align: center;
  padding: ${o => o.theme.spacing(4)} 0;

  div:last-child {
    padding: ${o => o.theme.spacing(1)} 0 0 0;
  }
`;
//# sourceMappingURL=styles.js.map